// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kv-0";